/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Access_Token_Limit_ReachedInputs */

const en_error_access_token_limit_reached = /** @type {(inputs: Error_Access_Token_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have as many live tokens as you may: revoke one first.`)
};

/**
* | output |
* | --- |
* | "You have as many live tokens as you may: revoke one first." |
*
* @param {Error_Access_Token_Limit_ReachedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_access_token_limit_reached = /** @type {((inputs?: Error_Access_Token_Limit_ReachedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Access_Token_Limit_ReachedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_access_token_limit_reached(inputs)
});